import React from 'react';
export function TablePageShimmer() {
  return <div className="space-y-6 animate-pulse" data-id="element-4252">
      {/* Header with button */}
      <div className="flex justify-between items-center" data-id="element-4253">
        <div className="h-6 w-48 bg-gray-200 rounded" data-id="element-4254" />
        <div className="h-10 w-32 bg-gray-200 rounded-md" data-id="element-4255" />
      </div>
      {/* Stats cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-4256">
        {[1, 2, 3, 4].map(i => <div key={i} className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-4257">
            <div className="h-4 w-24 bg-gray-200 rounded mb-2" data-id="element-4258" />
            <div className="h-8 w-32 bg-gray-200 rounded mb-2" data-id="element-4259" />
            <div className="h-3 w-20 bg-gray-200 rounded" data-id="element-4260" />
          </div>)}
      </div>
      {/* Table */}
      <div className="bg-white rounded-lg border border-gray-200" data-id="element-4261">
        {/* Table header */}
        <div className="p-4 border-b border-gray-200 flex justify-between items-center" data-id="element-4262">
          <div className="h-4 w-32 bg-gray-200 rounded" data-id="element-4263" />
          <div className="h-10 w-64 bg-gray-200 rounded-md" data-id="element-4264" />
        </div>
        {/* Table content */}
        <div className="overflow-x-auto" data-id="element-4265">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-4266">
            <thead data-id="element-4267">
              <tr data-id="element-4268">
                {[1, 2, 3, 4, 5].map(i => <th key={i} className="px-4 py-3" data-id="element-4269">
                    <div className="h-3 w-20 bg-gray-200 rounded" data-id="element-4270" />
                  </th>)}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-4271">
              {[1, 2, 3, 4, 5, 6, 7, 8].map(i => <tr key={i} data-id="element-4272">
                  {[1, 2, 3, 4, 5].map(j => <td key={j} className="px-4 py-4" data-id="element-4273">
                      <div className="h-4 w-24 bg-gray-200 rounded" data-id="element-4274" />
                    </td>)}
                </tr>)}
            </tbody>
          </table>
        </div>
        {/* Pagination */}
        <div className="p-4 border-t border-gray-200 flex justify-between items-center" data-id="element-4275">
          <div className="h-4 w-32 bg-gray-200 rounded" data-id="element-4276" />
          <div className="flex gap-2" data-id="element-4277">
            {[1, 2, 3, 4].map(i => <div key={i} className="h-8 w-8 bg-gray-200 rounded" data-id="element-4278" />)}
          </div>
        </div>
      </div>
    </div>;
}